import styled from "styled-components";

export const ModalContentWrapper = styled.div`
  background-color: #fff;
  padding: 20px;
  border-radius: 10px;
  min-width: 400px;
`;
